import { Dialog, DialogContent, Button, DialogActions } from "@mui/material";
import ReportRollsPdf from "./ReportRollsPdf";

const DialogReport = ({ openReport, handleClose, rollsData, rollsDataDelete }) => {
  return (
    <Dialog fullWidth maxWidth="lg" open={openReport} onClose={handleClose}>
      <DialogContent>
        <ReportRollsPdf rollsData={rollsData} rollsDataDelete={rollsDataDelete} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color={"secondary"} variant="contained">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogReport;
